import ApuOrderDetails from "modules/checkout/API/apu-order-api";
import ActionConstants from "../action-constants";
import Action from "./Action";

class ApuOrderApiActions extends Action {

  static getApuOrderData(productId) {
    return async (dispatch) => {
      const response = await ApuOrderDetails.getApuOrderData(
        productId
      );

        dispatch(ApuOrderApiActions.setApuOrderData(response));
    };
  }

  private static setApuOrderData(data) {
    return {
      type: ActionConstants.APU_ORDER_DATA,
      payload: data
    };
  }
}

export default ApuOrderApiActions;
